import styled from 'styled-components';

export const TestsPageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TestsContentWrapper = styled.div`
  width: calc(100% - 48px);
  height: 100%;
  padding: 24px;
`;
